export default __webpack_public_path__ + "static/footer-badge-3-6b7ea3ef2be31323a004e34a7a1b845a.svg";